//import { t } from 'i18next';
import React, {
  useState,
  useContext,
  useLayoutEffect,
  useEffect,
  useRef,
} from "react";
import { PONERA_ROUTES } from "routes";
import accountService from "api/accountService";
import Feedback from "components/Layout/Feedback";
import { storeActions } from "stores/storeHelpers";
import AppBar from "@mui/material/AppBar";
import { Button } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import FeedbackIcon from "@mui/icons-material/Feedback";
import { CardContext } from "./CardContext";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import LogoutIcon from "@mui/icons-material/Logout";
import Menu from "@mui/material/Menu";
import PersonAddDisabledIcon from "@mui/icons-material/PersonAddDisabled";
import PersonIcon from "@mui/icons-material/Person";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import { Avatar, ListItemText, ListItemIcon } from "@mui/material";
import PersonAddDisabledTwoToneIcon from "@mui/icons-material/PersonAddDisabledTwoTone";
import { useTheme } from "@mui/material/styles";
import { ColorModeContext } from "context/ColorModeContext";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import i18next from "i18next";
import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import { useNavigate } from "react-router-dom";
import Footer from "components/Footer/Footer";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";
import Collapse from "@mui/material/Collapse";

const defaultAvatarUrl = "/img/profile-circle.svg";

const UserMenuItem = (props) => {
  const { profile } = props.user;
  const { t, palette } = props;
  //const navigate = useNavigate();

  const toProperCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  const impersonating = props.user.impersonating;

  const stopImpersonate = () => {
    storeActions.setIsLoading(true);
    accountService
      .stopImpersonate()
      .then((resp) => {
        window.location.href = PONERA_ROUTES.DASHBOARD;
        //navigate("/dashboard");
        // setTimeout(() => {
        //   window.location = "/dashboard";
        // }, 2000);
      })
      .catch((err) => {
        storeActions.setIsLoading(false);
      });
  };

  return (
    <>
      <MenuItem>
        <ListItemIcon>
          <PersonIcon />
        </ListItemIcon>
        <ListItemText>
          {toProperCase(profile.firstName + " " + profile.lastName)}
        </ListItemText>
      </MenuItem>

      {impersonating && (
        <>
          <MenuItem onClick={stopImpersonate}>
            <ListItemIcon>
              {palette === "dark" ? (
                <PersonAddDisabledIcon />
              ) : (
                <PersonAddDisabledTwoToneIcon />
              )}
            </ListItemIcon>
            <ListItemText>{t("global.label.stopimpersonate")}</ListItemText>
          </MenuItem>
        </>
      )}
    </>
  );
};

export function DashboardMenu(props) {
  const { ContestoApp } = props;
  const { cards } = useContext(CardContext);
  const { t } = i18next;
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const navigate = useNavigate();
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [TermsOpen, setTermsOpen] = useState(false);
  const [privacyDropdownOpen, setPrivacyDropdownOpen] = useState(false);
  const [state, setState] = useState({
    isMenuOpen: false,
    anchorEl: null,
    amchorElBurger: null,
  });

  const dropdownRef = useRef(null);
  const ariaLableCurrentUser = t("global.arialabel.currentuser");

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [anchorElBurger, setAnchorElBurger] = useState(null);

  const toggleMenu = (event) => {
    // Gestire l'apertura del menu
    const isMenuCurrentlyOpen = Boolean(anchorElBurger);
    setAnchorElBurger(isMenuCurrentlyOpen ? null : event.currentTarget);

    // Aggiornare lo stato per il cambio dell'icona
    setIsMenuOpen(!isMenuCurrentlyOpen);
  };

  useLayoutEffect(() => {
    const burgerMenus = document.querySelectorAll("body");
    burgerMenus.forEach((burgerMenu) => {
      if (theme.palette.mode === "dark") {
        burgerMenu.classList.add("dark");
      } else {
        burgerMenu.classList.remove("dark");
      }
    });
  }, [theme.palette.mode]);

  const handleOpenFeedback = () => {
    setState({
      ...state,
      isMenuOpen: false,
      anchorEl: null,
    });
    setFeedbackOpen(true);
  };

  const handleTermsOpen = () => {
    setState({
      ...state,
      isMenuOpen: false,
      anchorEl: null,
    });
    setTermsOpen(true);
  };

  const handleCloseTerms = () => {
    setTermsOpen(false);
  };

  const handleCloseFeedback = () => {
    setFeedbackOpen(false);
  };

  const togglePrivacyDropdown = () => {
    setPrivacyDropdownOpen(!privacyDropdownOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setPrivacyDropdownOpen(false);
    }
  };

  const handleFeedbackSubmit = (feedbackType, feedbackText) => { };

  const logout = () => {
    storeActions.setIsLoading(true);
    accountService
      .logout()
      .then(() => {
        sessionStorage.removeItem("ulg");
        window.location.href = PONERA_ROUTES.LOGIN;
      })
      .catch((err) => {
        storeActions.setErrorMessage(true, err.message);
        storeActions.setIsLoading(false);
      });
  };

  const handleMenu = (event) => {
    setState({
      ...state,
      anchorEl: event.currentTarget,
    });
    // console.log(state.anchorEl);
    // console.log(Boolean(state.anchorEl));
  };

  const handleCloseMenu = () => {
    setState({
      ...state,
      isMenuOpen: false,
      anchorEl: null,
    });
  };

  const handleBurgerMenu = (event) => {
    setState({
      ...state,
      anchorElBurger: event.currentTarget,
    });
    // console.log(state.anchorEl);
    // console.log(Boolean(state.anchorEl));
  };

  const handleBurgerCloseMenu = () => {
    setAnchorElBurger(null);
    setIsMenuOpen(false);
  };

  const handleMenuItemClick = (action) => {
    setAnchorElBurger(null);
    setIsMenuOpen(false);
    action(); // Esegue l'azione specifica dell'elemento del menu
  };

  const handleClose = () => {
    props.onClose && props.onClose();
  };

  const handleToggleColorMode = () => {
    colorMode.toggleColorMode();
    handleCloseMenu();
  };

  const handleMenuClick = (cardLink) => {
    const link = cardLink.replace(
      /\{\{companyId\}\}/g,
      props.user.profile.companyId
    );
    navigate(link);
    handleBurgerCloseMenu();
  };

  const impersonating = props.user.impersonating;
  const avatar = props.user.avatarUrl || defaultAvatarUrl;
  const showClose = props.showClose;
  const profile = props.user.profile;
  const iniziali = profile.firstName[0] + profile.lastName[0] || "??";

  const avatarTitle = [profile].map((el, i) => {
    return (
      (impersonating ? t("uman.users.impersonating") + " " : "") +
      el.firstName +
      " " +
      el.lastName +
      `\n` +
      el.companyName +
      `\n` +
      el.email
    );
  });

  const avatarAlt = profile.firstName + " " + profile.lastName;

  const bgAvatar = impersonating ? { bgcolor: "red", color: "white" } : {};

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 25,
    height: 25,
    background: theme.palette.mode === "dark" ? "black" : "white",
    color: theme.palette.mode === "dark" ? "white" : "black",
  }));

  const appBarClass = `header ${impersonating ? "impersonate" : ""}`;
  if (impersonating) {
    document.body.classList.add("impersonate");
  }
  useEffect(() => {
    if (privacyDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [privacyDropdownOpen]);

  return (
    <>
      <div className="container">
        <AppBar className={appBarClass}>
          <Toolbar>
            <Box
              sx={{
                position: "relative",
                flex: 2,
              }}
              className="burger-menu">
              <IconButton
                aria-hidden="true"
                tabIndex={0}
                size="large"
                edge="start"
                color="inherit"
                aria-label={
                  isMenuOpen
                    ? t("global.arialabel.burgermenuopen")
                    : t("global.arialabel.burgermenuclose")
                }
                onClick={toggleMenu}
                sx={{
                  margin: "0",
                  padding: "0",
                  transition: "transform 0.3s",
                  transform: isMenuOpen ? "rotate(90deg)" : "rotate(0deg)",
                }}>
                {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
              </IconButton>
              <Menu
                id="burger-menu-appbar"
                sx={{
                  top: "50px",
                  left: 0,
                  width: "100%",
                  "& .MuiPaper-root": {},
                }}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                anchorEl={anchorElBurger}
                open={Boolean(anchorElBurger)}
                onClose={handleBurgerCloseMenu}>
                {cards &&
                  cards.map((card, idx) => {
                    const link = card.to.replace(
                      /\{\{companyid\}\}/g,
                      props.user.profile.companyId
                    );
                    return (
                      <MenuItem key={idx} onClick={() => handleMenuClick(link)}>
                        <Link
                          to={link}
                          className="d-block"
                          aria-label={card.title}>
                          {card.title}
                        </Link>
                      </MenuItem>
                    );
                  })}
              </Menu>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flex: 4,
                textAlign: "center",
                justifyContent: "center",
              }}>
              <Box>
                <a
                  href="/dashboard"
                  title="Dashboard"
                  aria-hidden="true"
                  tabIndex={0}>
                  <img
                    className="logo logo-ponera"
                    src="./img/logo-ponera-white.svg"
                    alt="PONERA"
                  />
                </a>
              </Box>
            </Box>
            {showClose && <CloseIcon onClick={handleClose} />}

            {!showClose && (
              <Box
                className="account"
                sx={{
                  display: "flex",
                  flex: 2,
                  justifyContent: "flex-end",
                }}>
                <IconButton
                  aria-hidden="true"
                  tabIndex={0}
                  size="large"
                  aria-pressed="true"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                  sx={{
                    margin: "0",
                    padding: "0",
                  }}>
                  {/* <AccountCircle /> */}

                  <Badge
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    badgeContent={
                      impersonating ? (
                        <SmallAvatar
                          alt={t("uman.users.impersonating")}
                          title={t("uman.users.impersonating")}>
                          {<PersonIcon fontSize="small" />}
                        </SmallAvatar>
                      ) : null
                    }>
                    <Avatar
                      sx={{
                        ...bgAvatar,
                        color: "#282727",
                      }}
                      title={avatarTitle}
                      alt={avatarAlt}
                      src={avatar}
                      aria-label={ariaLableCurrentUser}>
                      {iniziali.toUpperCase()}
                    </Avatar>
                  </Badge>
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={state.anchorEl}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  sx={{ marginTop: "-40px" }}
                  open={Boolean(state.anchorEl)}
                  onClose={handleCloseMenu}>
                  <UserMenuItem {...props} t={t} palette={theme.palette.mode} />
                  <MenuItem onClick={handleToggleColorMode}>
                    <ListItemIcon>
                      {theme.palette.mode === "dark" ? (
                        <Brightness7Icon fontSize="small" />
                      ) : (
                        <Brightness4Icon fontSize="small" />
                      )}
                    </ListItemIcon>
                    <ListItemText>
                      {" "}
                      {t(
                        "global.app." +
                        (theme.palette.mode === "dark"
                          ? "lightmode_menu_item"
                          : "darkmode_menu_item")
                      )}
                    </ListItemText>
                  </MenuItem>
                  <MenuItem onClick={handleOpenFeedback}>
                    <ListItemIcon>
                      <FeedbackIcon />
                    </ListItemIcon>
                    <ListItemText>{t("global.app.feedback")}</ListItemText>
                  </MenuItem>
                  <Feedback
                    open={feedbackOpen}
                    onClose={handleCloseFeedback}
                    onSubmit={handleFeedbackSubmit}
                    ContestoApp={ContestoApp}
                  />
                  <MenuItem onClick={togglePrivacyDropdown}>
                    <ListItemIcon>
                      <PrivacyTipIcon />
                    </ListItemIcon>
                    <ListItemText>{t("global.app.privacy")}</ListItemText>
                  </MenuItem>
                  <Collapse
                    in={privacyDropdownOpen}
                    timeout="auto"
                    unmountOnExit>
                    <Box className="privacy__custom" ref={dropdownRef}>
                      <Footer />
                    </Box>
                  </Collapse>
                  {/* logout visibile solo se non sto impersonando */}
                  {!impersonating && (
                    <MenuItem onClick={logout}>
                      <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>
                        {t("global.app.logout_menu_item")}
                      </ListItemText>
                    </MenuItem>
                  )}
                </Menu>
                <Dialog open={TermsOpen} onClose={handleCloseTerms}>
                  <DialogTitle>{t("global.footer.terms-title")}</DialogTitle>
                  <DialogContent>
                    <Box
                      dangerouslySetInnerHTML={{
                        __html: t("global.footer.terms-text"),
                      }}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleCloseTerms} color="primary">
                      {t("global.btn.close")}
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
            )}
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
}
